"use client";

import { c as _c } from "react/compiler-runtime";
import { filterTypes as by } from "@repo/design-system/types/filter";
import { useLanguage } from "~/translations/loader/use-language";
import { GeoSelect } from "../filterbar/filters/geo-select-eon";
import { GroupSelect } from "../filterbar/filters/group-select-eon";
import { LocationSelect } from "../filterbar/filters/location-select-eon";
import { MultiSelect } from "../filterbar/filters/multi-select";
import { Searchbar } from "../filterbar/searchbar-eon";
export function NewsletterFilterbarEonUk() {
  const $ = _c(16);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="lg:col-span-2"><Searchbar /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t.filterbar_geosearch_label) {
    t1 = <div className="lg:col-span-2"><GeoSelect label={t.filterbar_geosearch_label} /></div>;
    $[1] = t.filterbar_geosearch_label;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [by.EMPLOYMENT_TYPE, by.CONTRACT];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t.filterbar_filter3_placeholder) {
    t3 = <GroupSelect filterBy={t2} id="newsletter_contract" label={t.filterbar_filter3_placeholder} />;
    $[4] = t.filterbar_filter3_placeholder;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [by.REMOTE];
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t.filterbar_filter7_placeholder) {
    t5 = <MultiSelect filterBy={t4} id="newsletter_remote" label={t.filterbar_filter7_placeholder} />;
    $[7] = t.filterbar_filter7_placeholder;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t.filterbar_filter1_placeholder) {
    t6 = <LocationSelect id="newsletter_location" label={t.filterbar_filter1_placeholder} />;
    $[9] = t.filterbar_filter1_placeholder;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t1 || $[12] !== t3 || $[13] !== t5 || $[14] !== t6) {
    t7 = <section className="grid w-full grid-flow-row gap-y-2 pb-4 lg:grid-cols-2 lg:gap-4" id="newsletter_filterbar">{t0}{t1}{t3}{t5}{t6}</section>;
    $[11] = t1;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}